import React, { useEffect, useState } from "react";
import { AiOutlinePaperClip } from "react-icons/ai";
import { FiChevronDown } from "react-icons/fi";
import { IoMdEye, IoMdEyeOff } from "react-icons/io";

const countries = [
  { name: "United Arab Emirates", code: "+971", flag: "🇦🇪", maxLength: 9 },
  { name: "Afghanistan", code: "+93", flag: "🇦🇫", maxLength: 9 },
  { name: "Albania", code: "+355", flag: "🇦🇱", maxLength: 9 },
  { name: "Algeria", code: "+213", flag: "🇩🇿", maxLength: 9 },
  { name: "Andorra", code: "+376", flag: "🇦🇩", maxLength: 6 },
  { name: "Angola", code: "+244", flag: "🇦🇴", maxLength: 9 },
  { name: "Argentina", code: "+54", flag: "🇦🇷", maxLength: 10 },
  { name: "Armenia", code: "+374", flag: "🇦🇲", maxLength: 8 },
  { name: "Australia", code: "+61", flag: "🇦🇺", maxLength: 9 },
  { name: "Austria", code: "+43", flag: "🇦🇹", maxLength: 10 },
  { name: "Azerbaijan", code: "+994", flag: "🇦🇿", maxLength: 9 },
  { name: "Bahrain", code: "+973", flag: "🇧🇭", maxLength: 8 },
  { name: "Bangladesh", code: "+880", flag: "🇧🇩", maxLength: 10 },
  { name: "Belgium", code: "+32", flag: "🇧🇪", maxLength: 9 },
  { name: "Bhutan", code: "+975", flag: "🇧🇹", maxLength: 8 },
  { name: "Brazil", code: "+55", flag: "🇧🇷", maxLength: 11 },
  { name: "Canada", code: "+1", flag: "🇨🇦", maxLength: 10 },
  { name: "China", code: "+86", flag: "🇨🇳", maxLength: 11 },
  { name: "Denmark", code: "+45", flag: "🇩🇰", maxLength: 8 },
  { name: "Egypt", code: "+20", flag: "🇪🇬", maxLength: 10 },
  { name: "France", code: "+33", flag: "🇫🇷", maxLength: 9 },
  { name: "Germany", code: "+49", flag: "🇩🇪", maxLength: 11 },
  { name: "Greece", code: "+30", flag: "🇬🇷", maxLength: 10 },
  { name: "India", code: "+91", flag: "🇮🇳", maxLength: 10 },
  { name: "Indonesia", code: "+62", flag: "🇮🇩", maxLength: 10 },
  { name: "Ireland", code: "+353", flag: "🇮🇪", maxLength: 9 },
  { name: "Italy", code: "+39", flag: "🇮🇹", maxLength: 10 },
  { name: "Japan", code: "+81", flag: "🇯🇵", maxLength: 10 },
  { name: "Jordan", code: "+962", flag: "🇯🇴", maxLength: 9 },
  { name: "Kenya", code: "+254", flag: "🇰🇪", maxLength: 9 },
  { name: "Kuwait", code: "+965", flag: "🇰🇼", maxLength: 8 },
  { name: "Lebanon", code: "+961", flag: "🇱🇧", maxLength: 8 },
  { name: "Malaysia", code: "+60", flag: "🇲🇾", maxLength: 9 },
  { name: "Mexico", code: "+52", flag: "🇲🇽", maxLength: 10 },
  { name: "Netherlands", code: "+31", flag: "🇳🇱", maxLength: 9 },
  { name: "New Zealand", code: "+64", flag: "🇳🇿", maxLength: 9 },
  { name: "Nigeria", code: "+234", flag: "🇳🇬", maxLength: 10 },
  { name: "Norway", code: "+47", flag: "🇳🇴", maxLength: 8 },
  { name: "Oman", code: "+968", flag: "🇴🇲", maxLength: 8 },
  { name: "Pakistan", code: "+92", flag: "🇵🇰", maxLength: 10 },
  { name: "Philippines", code: "+63", flag: "🇵🇭", maxLength: 10 },
  { name: "Poland", code: "+48", flag: "🇵🇱", maxLength: 9 },
  { name: "Portugal", code: "+351", flag: "🇵🇹", maxLength: 9 },
  { name: "Qatar", code: "+974", flag: "🇶🇦", maxLength: 8 },
  { name: "Romania", code: "+40", flag: "🇷🇴", maxLength: 10 },
  { name: "Russia", code: "+7", flag: "🇷🇺", maxLength: 10 },
  { name: "Saudi Arabia", code: "+966", flag: "🇸🇦", maxLength: 9 },
  { name: "Singapore", code: "+65", flag: "🇸🇬", maxLength: 8 },
  { name: "South Africa", code: "+27", flag: "🇿🇦", maxLength: 9 },
  { name: "South Korea", code: "+82", flag: "🇰🇷", maxLength: 10 },
  { name: "Spain", code: "+34", flag: "🇪🇸", maxLength: 9 },
  { name: "Sri Lanka", code: "+94", flag: "🇱🇰", maxLength: 9 },
  { name: "Sweden", code: "+46", flag: "🇸🇪", maxLength: 9 },
  { name: "Switzerland", code: "+41", flag: "🇨🇭", maxLength: 9 },
  { name: "Syria", code: "+963", flag: "🇸🇾", maxLength: 9 },
  { name: "Thailand", code: "+66", flag: "🇹🇭", maxLength: 9 },
  { name: "Turkey", code: "+90", flag: "🇹🇷", maxLength: 10 },
  { name: "Ukraine", code: "+380", flag: "🇺🇦", maxLength: 9 },
  { name: "United Kingdom", code: "+44", flag: "🇬🇧", maxLength: 10 },
  { name: "United States", code: "+1", flag: "🇺🇸", maxLength: 10 },
  { name: "Vietnam", code: "+84", flag: "🇻🇳", maxLength: 9 },
  { name: "Yemen", code: "+967", flag: "🇾🇪", maxLength: 9 },
];

const Input = ({
  isPhoneNumber,
  onCountryChange,
  className,
  float,
  icon,
  type,
  isMinimumDate = true,
  password,
  name,
  placeholder,
  label,
  floatold,
  passwordold,
  textarea,
  error,
  disabled,
  countryCodeValue,
  left,
  right,
  ...props
}) => {
  const [passwordvisible, setpasswordvisible] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState(countries[0]);
  const [showDropdown, setShowDropdown] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState("");
  useEffect(() => {
    if (countryCodeValue) {
      let country = countries?.find((option) => option.code === countryCodeValue);
      setSelectedCountry(country);
    }
  }, [countryCodeValue]);
  const handleSelectCountry = (country) => {
    setSelectedCountry(country);
    setPhoneNumber("");
    setShowDropdown(false);
    if (onCountryChange) {
      onCountryChange(country.code);
    }
  };
  const [searchTerm, setSearchTerm] = useState("");

  const filteredCountries = countries.filter(
    (country) => country.name.toLowerCase().includes(searchTerm.toLowerCase()) || country.code.includes(searchTerm)
  );

  const handlePhoneInput = (e) => {
    const value = e.target.value.replace(/\D/g, "");
    if (value.length <= selectedCountry.maxLength) {
      setPhoneNumber(value);
    }
  };
  const [isFocused, setIsFocused] = useState(false);

  return isPhoneNumber ? (
    <div className={`${className} relative w-full`}>
      <div className="flex items-center border border-gray-300 rounded-lg overflow-hidden">
        <div
          className="flex items-center gap-1 px-2 py-3 bg-gray-100 w-[100px] cursor-pointer justify-center"
          onClick={() => {
            setShowDropdown(!showDropdown);
          }}
        >
          <span className="text-lg">{selectedCountry.flag}</span>
          <span className="text-blue-600 font-medium text-sm">{selectedCountry.code}</span>
          <FiChevronDown className="text-blue-600 text-lg" />
        </div>

        <input
          type="text"
          value={props.value}
          // placeholder={placeholder}
          // onChange={props.onChange}
          maxLength={selectedCountry.maxLength}
          disabled={disabled}
          className="flex-1 px-4 py-3 text-gray-800 border-none text-sm focus:outline-none focus:ring-0"
          onChange={(e) => {
            const val = e.target.value;
            if (/^\d*$/.test(val)) {
              props.onChange(e);
            }
          }}
        />
      </div>
      {error !== "" && <p className="text-red-500 text-sm mt-1">{error}</p>}
      {showDropdown && (
        <div className="absolute left-0 top-14 w-[180px] bg-white shadow-lg border border-gray-300 rounded-lg z-50">
          <input
            type="text"
            placeholder="Search..."
            className="w-full px-3 py-2 text-sm border-b border-gray-300 outline-none"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />

          <div className="h-[200px] overflow-y-auto">
            {filteredCountries.length > 0 ? (
              filteredCountries.map((country, index) => (
                <div
                  key={index}
                  className="flex items-center gap-2 px-3 py-2 cursor-pointer hover:bg-gray-100"
                  onClick={() => handleSelectCountry(country)}
                >
                  <span className="text-lg">{country.flag}</span>
                  <span className="text-sm font-medium">{country.code}</span>
                </div>
              ))
            ) : (
              <div className="px-3 py-2 text-sm text-gray-500">No results found</div>
            )}
          </div>
        </div>
        //    <div className="absolute left-0 top-14 w-[180px] h-[200px] overflow-y-auto bg-white shadow-lg border border-gray-300 rounded-lg z-50">
        //    {countries.map((country, index) => (
        //      <div
        //        key={index}
        //        className="flex items-center gap-2 px-3 py-2 cursor-pointer hover:bg-gray-100"
        //        onClick={() => handleSelectCountry(country)}
        //      >
        //        <span className="text-lg">{country.flag}</span>
        //        <span className="text-sm font-medium">{country.code}</span>
        //      </div>
        //    ))}
        //  </div>
      )}
    </div>
  ) : float ? (
    <div className={`${className} relative w-full`}>
      <label
        className={`absolute left-3 pointer-events-none transition-all duration-300 ease-in-out bg-white px-1
          ${isFocused || props.value || left ? "text-xs -top-2 px-1" : "top-4 text-sm"}
        text-gray-600 font-medium`}
      >
        {label ? label : placeholder}
      </label>
      {left ? (
        <span className="absolute left-3 top-7 transform -translate-y-1/2 text-sm text-gray-900 font-semibold">
          {left}
        </span>
      ) : null}
      <input
        type={type || "email"}
        min={type === "date" && isMinimumDate ? new Date().toISOString().split("T")[0] : undefined}
        className={`block w-full text-sm py-4 ${
          left ? "px-12" : "px-3"
        } border border-gray-300 rounded-lg focus:outline-none focus:ring-0 focus:border-primary`}
        name={name}
        disabled={disabled}
        value={props.value}
        onChange={props.onChange}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(!!props.value)}
        style={{
          color: isFocused || props.value || left ? "black" : "white",
        }}
      />
      {right ? (
        <span className="absolute right-3 top-1/2 transform -translate-y-1/2 text-sm text-gray-900 font-semibold">
          {right}
        </span>
      ) : null}

      {error !== "" && <p className="text-red-500 text-sm mt-1">{error}</p>}
      {icon && <span className="absolute inset-y-0 right-3 flex items-center text-gray-600 text-lg">{icon}</span>}
    </div>
  ) : password ? (
    <div className="mb-6 relative mt-5">
      {/* Label */}
      <label
        className={`absolute left-3 pointer-events-none transition-all duration-300 ease-in-out bg-white px-1
        ${isFocused || props.value ? "text-xs -top-2 px-1" : "top-4 text-sm"}
      text-gray-600 font-medium`}
        htmlFor="password"
      >
        {label ? label : "Password"}
      </label>

      <input
        id="password"
        type={passwordvisible ? "text" : "password"}
        name={name}
        className="w-full py-4 px-3 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-0 focus:border-primary"
        // placeholder={placeholder}
        disabled={disabled}
        value={props.value}
        onChange={props.onChange}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(!!props.value)}
      />

      <div className="absolute inset-y-0 right-3 flex items-center">
        <div
          onClick={() => setpasswordvisible(!passwordvisible)}
          className="absolute top-[10px] right-[10px] cursor-pointer"
        >
          {passwordvisible ? (
            <IoMdEye className="text-[gray] w-[25px] h-[25px] mt-[3px]" />
          ) : (
            <IoMdEyeOff className="text-[gray] w-[25px] h-[25px] mt-[3px]" />
          )}
        </div>
      </div>
      {error !== "" && <p className="text-red-500 text-sm mt-1">{error}</p>}
    </div>
  ) : passwordold ? (
    <div className="mb-6 relative mt-5">
      {label ? (
        <label className="block pointer-events-none text-sm font-medium mb-2" htmlFor="password">
          Password
        </label>
      ) : null}
      <input
        id="password"
        type={type ? type : "password"}
        name={name}
        className="w-full  py-4 px-3 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
        // placeholder={placeholder}
        value={props.value}
        disabled={disabled}
        onChange={props.onChange}
      />
      <div className="absolute inset-y-0 right-3 flex items-center">
        <div
          onClick={() => {
            setpasswordvisible(!passwordvisible);
          }}
          className="absolute top-[10px] right-[10px]"
        >
          {passwordvisible ? (
            <IoMdEye className="text-[gray] w-[25px] h-[25px] mt-[3px]" />
          ) : (
            <IoMdEyeOff className="text-[gray] w-[25px] h-[25px] mt-[3px]" />
          )}
        </div>
      </div>
    </div>
  ) : floatold ? (
    <div className={`${className} relative w-full`}>
      <span className="relative top-3 left-2 bg-white px-2">
        <label className="text-xs font-medium text-gray-600  pointer-events-none">{label}</label>
      </span>

      <input
        type={type ? type : "email"}
        className="block text-sm w-full py-4 px-3 border border-gray-300 rounded-lg text-gray-800 focus:outline-none focus:ring-0"
        // placeholder={placeholder}
        name={name}
        value={props.value}
        disabled={disabled}
        onChange={props.onChange}
      />
      {icon && <span className="absolute inset-y-0 right-3 top-6 flex items-center text-gray-600 text-lg">{icon}</span>}
    </div>
  ) : type == "file" ? (
    <div>
      <div className="relative top-2.5 left-4 bg-white px-1 w-[150px] mt-[-25px]">
        <label className="text-sm font-medium text-gray-600">Attachment</label>
      </div>
      <div className="flex border border-gray-300 py-[14px] rounded-lg">
        <input
          style={{ paddingLeft: 15 }}
          className="w-full text-xs text-gray-500 focus:outline-none relative"
          onChange={props.onChange}
          disabled={disabled}
          type="file"
          label=""
          float
        />
        <AiOutlinePaperClip className="w-6 h-6  relative text-gray-400 right-[2.5%]" />
      </div>
      {error !== "" && <p className="text-red-500 text-sm mt-1">{error}</p>}
    </div>
  ) : textarea ? (
    <div className={`${className} relative w-full`}>
      <label
        className={`absolute left-3  pointer-events-none transition-all duration-300 ease-in-out bg-white px-1
          ${isFocused || props.value ? "text-xs -top-0 px-1 pr-10" : "top-5 text-sm pr-20"}
        text-gray-600 font-medium`}
      >
        {label ? label : placeholder}
      </label>
      <textarea
        // placeholder={placeholder}
        value={props.value}
        onChange={props.onChange}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(!!props.value)}
        className="border mt-2 text-sm border-gray-300 rounded-lg px-4 py-2 w-full h-32 focus:outline-none focus:ring-0 focus:border-primary"
        style={{ color: isFocused || props.value ? "black" : "white" }}
      />
      {error !== "" && <p className="text-red-500 text-sm mt-1">{error}</p>}
    </div>
  ) : (
    <div className={`relative w-full ${className}`}>
      {label ? (
        <label className={`block pointer-events-none text-sm font-medium mb-2 ${className}`} htmlFor="email">
          {label}
        </label>
      ) : null}
      <input
        id="email"
        type={type ? type : "email"}
        className="w-full text-sm py-4 px-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
        // placeholder={placeholder}
        name={name}
        disabled={disabled}
        value={props.value}
        onChange={props.onChange}
      />
    </div>
  );
};

export default Input;

// import React, { useState } from "react";
// import { FiChevronDown } from "react-icons/fi";
// import { IoMdEye, IoMdEyeOff } from "react-icons/io";

// const countries = [
//   { name: "United Arab Emirates", code: "+971", flag: "🇦🇪", maxLength: 9 },
//   { name: "United States", code: "+1", flag: "🇺🇸", maxLength: 10 },
//   { name: "India", code: "+91", flag: "🇮🇳", maxLength: 10 },
//   { name: "United Kingdom", code: "+44", flag: "🇬🇧", maxLength: 10 },
// ];

// const Input = ({
//   isPhoneNumber,
//   className,
//   float,
//   icon,
//   type,
//   password,
//   name,
//   placeholder,
//   label,
//   ...props
// }) => {
//   const [passwordvisible, setpasswordvisible] = useState(false);
//   const [selectedCountry, setSelectedCountry] = useState(countries[0]);
//   const [showDropdown, setShowDropdown] = useState(false);
//   const [phoneNumber, setPhoneNumber] = useState("");

//   const handleSelectCountry = (country) => {
//     setSelectedCountry(country);
//     setPhoneNumber("");
//     setShowDropdown(false);
//   };

//   const handlePhoneInput = (e) => {
//     const value = e.target.value.replace(/\D/g, "");
//     if (value.length <= selectedCountry.maxLength) {
//       setPhoneNumber(value);
//     }
//   };

//   return isPhoneNumber ? (
//     <div className={`${className} relative w-full`}>
//       <div className="flex items-center border border-gray-300 rounded-lg overflow-hidden">
//         <div
//           className="flex items-center gap-1 px-2 py-3 bg-gray-100 w-[100px] justify-between cursor-pointer"
//           onClick={() => setShowDropdown(!showDropdown)}
//         >
//           <span className="text-lg">{selectedCountry.flag}</span>
//           <span className="text-blue-600 font-medium text-sm">
//             {selectedCountry.code}
//           </span>
//           <FiChevronDown className="text-blue-600 text-lg" />
//         </div>

//         <input
//           type="text"
//           value={phoneNumber}
//           placeholder={placeholder}
//           onChange={handlePhoneInput}
//           maxLength={selectedCountry.maxLength}
//           className="flex-1 px-4 py-3 text-gray-800 border-none text-sm focus:outline-none focus:ring-0"
//         />
//       </div>

//       {showDropdown && (
//         <div className="absolute left-0 top-14 w-[180px] bg-white shadow-lg border border-gray-300 rounded-lg z-50">
//           {countries.map((country, index) => (
//             <div
//               key={index}
//               className="flex items-center gap-2 px-3 py-2 cursor-pointer hover:bg-gray-100"
//               onClick={() => handleSelectCountry(country)}
//             >
//               <span className="text-lg">{country.flag}</span>
//               <span className="text-sm font-medium">{country.code}</span>
//             </div>
//           ))}
//         </div>
//       )}
//     </div>
//   ) : float ? (
//     <div className={`${className} relative w-full`}>
//       <span className="relative top-3 left-2 bg-white px-2">
//         <label className="text-xs font-medium text-gray-600">{label}</label>
//       </span>

//       <input
//         type={type ? type : "email"}
//         className="block text-sm w-full py-4 px-3 border border-gray-300 rounded-lg text-gray-800 focus:outline-none focus:ring-0"
//         placeholder={placeholder}
//         name={name}
//         value={props.value}
//         onChange={props.onChange}
//       />
//       {icon && (
//         <span className="absolute inset-y-0 right-3 top-6 flex items-center text-gray-600 text-lg">
//           {icon}
//         </span>
//       )}
//     </div>
//   ) : password ? (
//     <div className="mb-6 relative mt-5">
//       {label ? (
//         <label className="block text-sm font-medium mb-2" htmlFor="password">
//           Password
//         </label>
//       ) : null}
//       <input
//         id="password"
//         type={type ? type : "password"}
//         name={name}
//         className="w-full  py-4 px-3 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
//         placeholder={placeholder}
//         value={props.value}
//         onChange={props.onChange}
//       />
//       <div className="absolute inset-y-0 right-3 flex items-center">
//         <div
//           onClick={() => {
//             setpasswordvisible(!passwordvisible);
//           }}
//           className="absolute top-[10px] right-[10px]"
//         >
//           {passwordvisible ? (
//             <IoMdEye className="text-[gray] w-[25px] h-[25px] mt-[3px]" />
//           ) : (
//             <IoMdEyeOff className="text-[gray] w-[25px] h-[25px] mt-[3px]" />
//           )}
//         </div>
//       </div>
//     </div>
//   ) : (
//     <div className={`relative w-full ${className}`}>
//       {label ? (
//         <label
//           className={`block text-sm font-medium mb-2 ${className}`}
//           htmlFor="email"
//         >
//           {label}
//         </label>
//       ) : null}
//       <input
//         id="email"
//         type={type ? type : "email"}
//         className="w-full text-sm py-4 px-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
//         placeholder={placeholder}
//         name={name}
//         value={props.value}
//         onChange={props.onChange}
//       />
//     </div>
//   );
// };

// export default Input;
